// src/store/middleware/chatManagerMiddleware.js
import { ChatManager } from "../../utils/ChatManager";
import {
  ADD_MESSAGE,
  RECEIVE_MESSAGE,
  UPDATE_MESSAGE,
  DELETE_MESSAGE,
  DELETE_CHAT,
  DELETE_ALL_CHATS,
  CLEAR_ALL_CHAT,
} from "../features/message/messageTypes";

let chatManagerInstance = null;

const getChatManager = () => {
  if (!chatManagerInstance) {
    chatManagerInstance = new ChatManager();
  }
  return chatManagerInstance;
};

export const chatManagerMiddleware = () => (next) => async (action) => {
  const result = next(action);
  const chatManager = getChatManager();

  // Sync Redux actions with ChatManager
  switch (action.type) {
    case ADD_MESSAGE:
    case RECEIVE_MESSAGE:
      await chatManager.addMessage(action.message);
      break;

    case UPDATE_MESSAGE: {
      const { chatId, messageId, updatedFields } = action.payload;
      await chatManager.updateMessage(chatId, messageId, updatedFields);
      break;
    }

    case DELETE_MESSAGE:
      await chatManager.deleteMessage(action.chatId, action.messageId);
      break;

    case DELETE_CHAT:
      await chatManager.deleteChat(action.chatId);
      break;

    case DELETE_ALL_CHATS:
    case CLEAR_ALL_CHAT:
      await chatManager.clearAllChats(action.chatId);
      break;
  }

  return result;
};

export { getChatManager };
